import React from 'react';

/**
 * Support ticket preview / success card in web chat.
 * Same look as the booking card (developer4's design, 0f04919); `card` comes from
 * getTicketCard() in ./ticketCard.js. Plan: docs/plans/SUPPORT_TICKET_CARD_PLAN.md
 *
 * @param {object} card     {type:'preview', intro, location, subject, details, prompt}
 *                          or {type:'success', reference, message}
 * @param {object} ticket   for a success card: the preview it confirms (subject/location/details)
 * @param {object} image    the user's attached photo {url, filename}, if any
 * @param {function} onImageLoad  called when the photo has loaded (keeps the scroll anchored)
 */
const TicketCard = ({ card, ticket = null, image = null, onImageLoad }) => {
  const isSuccess = card.type === 'success';
  const fields = isSuccess ? ticket : card;
  const lead = isSuccess ? card.message : card.intro;

  return (
    <>
      {lead && <p className="ticket-card-lead">{lead}</p>}
      <div className="booking-confirmation-card ticket-card">
        {image?.url && (
          <div className="booking-card-image">
            <img src={image.url} alt={image.filename || 'Attached photo'} onLoad={onImageLoad} />
          </div>
        )}
        <div className="booking-card-details">
          <h3 className="booking-room-title">{isSuccess ? '✓ TICKET SUBMITTED' : '🎫 SUPPORT TICKET'}</h3>
          {fields?.subject && <div className="booking-detail-row">{fields.subject}</div>}
          {fields?.location && <div className="booking-detail-row">📍 {fields.location}</div>}
          {fields?.details && (
            <div className="booking-detail-row" style={{ whiteSpace: 'pre-line' }}>
              {fields.details}
            </div>
          )}
          {isSuccess && card.reference && (
            <div className="booking-detail-row ticket-reference">
              <strong>Reference: {card.reference}</strong>
            </div>
          )}
        </div>
      </div>
      {!isSuccess && card.prompt && (
        <div className="booking-action-text">
          <p>{card.prompt}</p>
        </div>
      )}
    </>
  );
};

export default TicketCard;
